/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'roomplan-feratel': {
    width: 16,
    height: 32,
    viewBox: '0 -1 16 32',
    data: '<metadata id="metadata62"/><defs id="defs60"/><g id="Ebene_1-2" data-name="Ebene 1" transform="translate(-108.89 8.745)" _fill="#000"><g id="g930" transform="matrix(.2254 0 0 .2254 85.12 1.253)"><path pid="0" id="Pfad_4148" data-name="Pfad 4148" class="cls-1" d="M172 41.2a275.45 275.45 0 01-30.93 1.56 284.91 284.91 0 01-31.18-1.55V31.09H164l-54.11-10V3.26A302.22 302.22 0 01141 1.62a272 272 0 0131 1.65v16.65h-54.43L172 30z" _fill="#000"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/roomplan-feratel.js